import React, { useState, useEffect } from "react";
import { Table, Button, Form } from "react-bootstrap";
import { FaEye, FaDownload, FaRegFilePdf } from "react-icons/fa";
import axios from "axios";

const PdfList = () => {
  const [pdfFiles, setPdfFiles] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);


  const loadDocuments = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/documents`, {
        params: { page, limit: 10, search }
      });
      setPdfFiles(res.data.data);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Erro ao carregar documentos:", error);
    }
  };

  useEffect(() => {
    loadDocuments();
  }, [page, search]);

  const handleDownload = (fileName) => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_API_IMG}/assets/pdfs/${fileName}`;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const iconStyle = {
    color: '#D00000',
    fontSize: '24px',
    marginRight: '8px',
  };

  return (
    <div className="container my-4">
      <h2 className="mb-4">Contratos</h2>
      <Form.Control
        type="text"
        placeholder="Buscar por nome do contrato..."
        className="mb-3"
        value={search}
        onChange={(e) => {
          setPage(1); // volta pra primeira página ao buscar
          setSearch(e.target.value);
        }}
      />

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Nome do Contrato</th>
            <th style={{ width: "9%" }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {pdfFiles.map((pdf) => (
            <tr key={pdf._id}>
              <td><FaRegFilePdf style={iconStyle} /> {pdf.name}</td>
              <td>
                <Button
                  variant="outline-success"
                  href={`${process.env.REACT_APP_API_IMG}/assets/pdfs/${pdf.fileName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaEye />
                </Button>{' '}
                <Button
                  variant="outline-primary"
                  onClick={() => handleDownload(pdf.fileName)}
                >
                  <FaDownload />
                </Button>

              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <span>Página {page} de {totalPages}</span>
        <div>
          <Button
            variant="secondary"
            disabled={page <= 1}
            onClick={() => setPage(page - 1)}
            className="me-2"
          >
            Anterior
          </Button>
          <Button
            variant="secondary"
            disabled={page >= totalPages}
            onClick={() => setPage(page + 1)}
          >
            Próxima
          </Button>
        </div>
      </div>

    </div>
  );
};

export default PdfList;
